import React from 'react';
import PurchasesTable from '../components/PurchasesTable';
import { Box, Typography } from '@mui/material';

interface DepositsPageProps {
  tenantId?: number;
}

const DepositsPage: React.FC<DepositsPageProps> = ({ tenantId }) => {
  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Deposits (Platform Only)</Typography>
      <PurchasesTable tenantId={tenantId} showDepositsOnly />
    </Box>
  );
};

export default DepositsPage; 